import { apiClient } from '@/services/ApiClient.js'
import { build_query } from '@/utilities/helpers.js'

export const allowedFilters = ['name']

export default {
  getProducts(query) {
    return apiClient
      .get('products', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getMobileProducts(query) {
    return apiClient
      .get('mobile-products', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProduct(id) {
    return apiClient
      .get('products/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  editProduct(id, form) {
    let formData = new FormData()

    if (form.mobileData.file) {
      formData.append('mobile_image', form.mobileData.file)
    }
    let body = JSON.stringify({
      product_item: form.productItem,
      mobile_data: form.mobileData,
      units: form.productUnitList,
      default_image: form.default_image
    })

    formData.append('body', body)

    return apiClient
      .postForm('products/' + id + '?_method=PATCH', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createProduct(form) {
    let formData = new FormData()

    if (form.mobile_image) {
      formData.append('mobile_image', form.mobile_image)
    }

    let body = JSON.stringify({
      product_item: form.productItem,
      mobile_data: form.mobileData,
      units: form.productUnitList
    })

    formData.append('body', body)

    return apiClient
      .postForm('products', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  exportProducts(query) {
    return apiClient
      .get('products/export-products', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getUnits() {
    return apiClient
      .get('units')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveProductUnits(productId, units) {
    return apiClient
      .post('products/' + productId + '/units', { units: units })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteProductUnitItem(productId, unitId) {
    return apiClient
      .delete('products/' + productId + '/units/' + unitId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteProduct(id) {
    return apiClient
      .delete('products/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  uploadImage(id, form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('products/' + id + '/image', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveRegions(id, regions) {
    return apiClient
      .patch('products/' + id + '/save-regions', {
        regions
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  saveBrands(id, brands) {
    return apiClient
      .patch('products/' + id + '/save-brands', {
        brands
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getProductUnits(productId) {
    return apiClient
      .get('products/' + productId + '/units')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getSimilarProductNameList(query) {
    const newQuery = build_query(query, allowedFilters)
    return apiClient
      .get('products', {
        params: newQuery
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
